// src/analytics.js
// Camada fina sobre o Firebase Analytics — usada pra rastrear o funil de
// aquisição (onboarding → cadastro → primeiro uso). Só funciona no app
// nativo (Android); em web, os eventos são ignorados silenciosamente até
// termos uma configuração Firebase própria pra web.
import { FirebaseAnalytics } from "@capacitor-firebase/analytics";
import { Capacitor } from "@capacitor/core";

export async function initAnalytics() {
  if (!Capacitor.isNativePlatform()) return;
  try {
    await FirebaseAnalytics.setEnabled({ enabled: true });
  } catch (e) {
    console.log("Firebase Analytics init error:", e);
  }
}

// name deve seguir o padrão do Firebase: snake_case, até 40 caracteres.
export async function logFunnelEvent(name, params = {}) {
  if (!Capacitor.isNativePlatform()) return;
  try {
    await FirebaseAnalytics.logEvent({ name, params });
  } catch (e) {
    console.log(`Firebase Analytics log error (${name}):`, e);
  }
}
